import { CartItemInput } from 'contexts/type/cart-type';
import { buildFingerPrint } from 'contexts/cart/utils/build-fingerprint';

interface AddToCartArgs {
  prev: CartItemInput[];
  updates: CartItemInput[];
}

export const addToCart = ({ prev, updates }: AddToCartArgs): CartItemInput[] => {
  if (prev.length === 0) {
    return updates.filter((item) => item.quantity > 0);
  }

  const updatesMap = new Map<string, CartItemInput>();
  updates.forEach((update) => updatesMap.set(buildFingerPrint(update), update));
  const resultCartItems = new Map<string, CartItemInput>();

  prev.forEach((prevItem) => {
    const prevItemFingerPrint = buildFingerPrint(prevItem);
    const updateForItem = updatesMap.get(prevItemFingerPrint);

    if (updateForItem !== undefined) {
      const updatedItem = {
        ...prevItem,
        quantity: prevItem.quantity + updateForItem.quantity,
      };
      // remove item from updates map after update
      updatesMap.delete(prevItemFingerPrint);

      // fingerprint should stay same since we just adding items (changing their quantity)
      resultCartItems.set(prevItemFingerPrint, updatedItem);
      return;
    }

    resultCartItems.set(prevItemFingerPrint, prevItem);
  });

  // add leftovers
  updatesMap.forEach((update, key) => {
    const existingItem = resultCartItems.get(key);
    if (existingItem) {
      resultCartItems.set(key, { ...update, quantity: existingItem.quantity + update.quantity });
    }
    resultCartItems.set(key, update);
  });

  return Array.from(resultCartItems.values());
};
